<template>
  <div id="rbacModulesModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <button type="button" class="close" @click="cancelPermissions">&times;</button>
          <div class="modal-title">{{ serviceModule.name }}</div>
          <hr />
        </div>
        <div class="modal-body module-access">
          <div class="row m-0 align-right col-xs-12">
            <button class="btn emergo-green-button header-buttons" @click="addModule">
              <i class="fa fa-plus mr-4"></i>Add Modules
            </button>
            <button class="btn emergo-green-button ml-25" @click="addOperations">
              <i class="fa fa-plus mr-4"></i>Add Sub Modules
            </button>
          </div>
          <template v-for="(module, index) in serviceModule.modules">
            <div :key="index" class="module-text col-xs-12 col-sm-12">
              <div class="label_container">
                <span class="checkbox">
                  <label>
                  <input type="checkbox" v-model="module.access" />
                  <span class="cr"></span></label>
                </span>
                <div
                  class="ml-18 cursor-pointer flex_grow_1"
                  data-toggle="collapse"
                  :data-target="'#' + index + '_collapse'"
                >
                  <span class="col-sm-8 col-xs-6">{{ module.name }}</span>
                  <span
                    class="col-sm-3 col-xs-4 xs-pd-0"
                    @click="deleteModule('module', module.name)"
                  >
                    <a class="text-color-delete-red">
                      <img
                        src="/static/images/icons/delete_icon.svg"
                        class="tracker-images"
                        alt="delete-icon"
                      />
                      <span>Delete</span>
                    </a>
                  </span>
                  <span class="collapse_arrow fa fa-angle-down"></span>
                </div>
              </div>
              <div :id="index + '_collapse'" class="collapse mr-lt-30">
                <div
                  class="desc_text mr-rt-30"
                  v-for="(operation, index) in module.operations"
                  :key="index"
                >
                  <span class="checkbox inline-checkbox">
                    <label>
                    <input type="checkbox" v-model="operation.access" />
                    <span class="cr"></span></label>
                  </span>
                  <span class="cust_label wd-60">{{ operation.name }}</span>
                  <div
                    class="inline pd-0"
                    @click="deleteModule('operation', module.name, operation.name)"
                  >
                    <a class="text-color-delete-red">
                      <img
                        src="/static/images/icons/delete_icon.svg"
                        class="tracker-images"
                        alt="delete-icon"
                      />
                      <span>Delete</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <rbac-add-module v-if="addModuleFlag" :serviceModule="serviceModule" />
          <rbac-add-sub-modules v-if="addOperationsFlag" :serviceModule="serviceModule" />
        </div>
        <div class="modal-footer modal-bgcolor">
          <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
            <div class="col-md-3 col-md-offset-6 col-sm-offset-4 col-sm-4 col-xs-6 xs-pd-lt-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="cancelPermissions()"
              >
                Cancel
              </button>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 xs-pd-lt-0 xs-pd-rt-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="updatePermissions()"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import RBACAddModule from './RBACAddModule.vue';
import RBACAddSubModules from './RBACAddSubModules.vue';

export default {
  components: {
    'rbac-add-module': RBACAddModule,
    'rbac-add-sub-modules': RBACAddSubModules
  },
  data() {
    return {
      addModuleFlag: false,
      addOperationsFlag: false,
      serviceModule: {}
    };
  },
  props: ['roleServices', 'serviceId'],
  watch: {
    serviceId() {
      if (this.serviceId) {
        this.serviceModule = cloneDeep(
          this.roleServices.find((service) => service.id === this.serviceId)
        );
      }
    },
    roleServices() {
      if (this.serviceId) {
        this.serviceModule = cloneDeep(
          this.roleServices.find((service) => service.id === this.serviceId)
        );
      }
    }
  },
  methods: {
    updatePermissions() {
      this.$emit('updatePermissions', this.serviceModule, this.serviceId);
      this.addModuleFlag = false;
      this.addOperationsFlag = false;
      this.serviceModule = {};
      $('#rbacModulesModal').modal('hide');
    },
    deleteModule(type, moduleName, operationName) {
      this.serviceModule.modules.forEach((module, index) => {
        if (type === 'module') {
          if (module.name === moduleName) {
            this.serviceModule.modules.splice(index, 1);
          }
        } else if (type === 'operation') {
          if (module.name === moduleName) {
            module.operations.forEach((operation, opIndex) => {
              if (operation.name === operationName) {
                module.operations.splice(opIndex, 1);
              }
            });
          }
        }
      });
    },
    addOperations() {
      this.addOperationsFlag = true;
      this.addModuleFlag = false;
    },
    addModule() {
      this.addModuleFlag = true;
      this.addOperationsFlag = false;
    },
    cancelPermissions() {
      this.$emit('updateServiceId');
      this.addModuleFlag = false;
      this.addOperationsFlag = false;
      this.serviceModule = {};
      $('#rbacModulesModal').modal('hide');
    }
  },
  mounted() {
    $('#rbacModulesModal').on('shown.bs.modal', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }
};
</script>
<style scoped lang="scss">
$font-family-Roboto: Roboto;
$font-style-normal: normal;

.mr-lt-30 {
  margin-left: 30px;
}
.mr-rt-30 {
  margin-right: 30px;
}
.collapse {
  div.desc_text {
    &:last-of-type {
      border-bottom: none;
    }
  }
}
div[aria-expanded='true'] {
  > .collapse_arrow {
    -webkit-transform: rotate(180deg); /* to support Safari and Android browser */
    -ms-transform: rotate(180deg); /* to support IE 9 */
    transform: rotate(180deg);
  }
}
.collapse_arrow {
  float: right;
  vertical-align: middle;
  font-size: $font-18;
}
.label_container {
  display: flex;
  align-items: center;
  padding: 8px 10px 8px 0px;
  border-bottom: 0.5px solid $gray74;
}
.flex_grow_1 {
  flex-grow: 1;
}
.flex_grow_0 {
  flex-grow: 0;
}
.cust_label {
  display: inline-block;
  font-size: $font-14;
}
.desc_text {
  padding-bottom: 8px;
  padding-top: 8px;
  font-size: 14px;
  border-bottom: 0.5px solid $gray74;
}
.module-text {
  padding-bottom: 0;
  padding-top: 0;
}
hr {
  margin-top: 8px;
  margin-bottom: 0px;
}
.modal-title {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-medium;
  font-size: $font-20;
  color: $primary;
}
.mem-name {
  font-family: $font-family-Roboto;
  font-style: $font-family-Roboto;
  font-weight: $font-weight-normal;
  font-size: $font-12;
  color: $black;
}
.modal-body {
  height: 60vh;
  padding-top: 5px;
  overflow-y: auto;
}
#permissionsAccess {
  > div {
    width: 75% !important;
    margin: 0px;
  }
}
.modal-content.first-modal-content {
  border-radius: 12px;
}
.modal-header {
  padding: 15px 30px;
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    line-height: 28px;
    color: $deep-gray;
    width: 17px;
    border-radius: 20px;
    font-weight: 300;
    outline: none;
    font-size: 38px;
    z-index: 1;
  }
}
.modal-header.modal-bgcolor {
  background-color: $deep-white;
  border: 0px;
  border-radius: 5px;
  padding-bottom: 0px;
}
.modal-footer.modal-bgcolor {
  background-color: $deep-white;
  border: 0px;
  border-radius: 10px;
}
.inline {
  display: inline;
}
.header-buttons {
  margin-right: 10px;
}
.wd-60 {
  width: 60%;
}
.inline {
  display: inline;
}
@media screen and (max-width: 767px) {
  .modal-header {
    padding: 15px;
  }
  .module-text {
    padding: 0;
  }
  .xs-p-0 {
    padding: 0;
  }
  .mr-rt-30 {
    margin-right: 15px;
  }
  .mr-lt-30 {
    margin-left: 15px;
  }
  #permissionsAccess {
    > div {
      width: 95% !important;
    }
  }
}
@media (max-width: 768px) and (max-width: 1024px) {
  .modal-dialog {
    vertical-align: top;
  }
  .modal-body {
    height: 35vh;
    overflow: auto;
  }
}
@media (width: 1024px) and (height: 768px) {
  .modal-body {
    height: 50vh;
  }
}
@media (device-width: 812px) and (device-height: 375px) {
  .modal-body {
    height: 52vh;
  }
}
@media only screen and (max-width: 576px) {
  .btn-add {
    &:last-child {
      margin-top: 3px;
    }
  }
  .header-buttons {
    margin-right: 0px;
    margin-bottom: 10px;
    padding: 6px 25px;
  }
  .ml-25 {
    margin-left: 25%;
  }
  .xs-pd-0 {
    padding: 0px;
  }
}
</style>
